import { IconButton, Link, Stack, Tooltip, Typography, useTheme } from "@mui/material";
import React from "react";
import { Links } from "src/constants";
import { useSession } from "src/hooks";
import { TaskItemDto, useEditTaskItemFocus } from "src/http";
import { MaterialSymbolIcon, MaterialSymbols } from "..";

interface Props {
  taskItem: TaskItemDto;
}

const TaskItemFocusCharm = (props: Props) => {
  const { userId: sessionUserId } = useSession();
  const { mutate: editTaskItemFocus, isLoading } = useEditTaskItemFocus();
  const theme = useTheme();

  const ownersInFocus = props.taskItem.owners.filter((x) => x.isFocused);
  const sessionUserOwnership = props.taskItem.owners.find((x) => x.user.userId === sessionUserId);

  function handleFocusClicked(e: React.MouseEvent) {
    e.stopPropagation();

    if (!sessionUserOwnership) {
      return;
    }

    editTaskItemFocus({
      taskItemGuid: props.taskItem.guid,
      isFocused: !sessionUserOwnership.isFocused,
      ownerGuid: sessionUserId,
    });
  }

  return (
    <Stack direction="row" sx={{ alignItems: "center" }}>
      <IconButton
        size="small"
        disabled={isLoading || !sessionUserOwnership}
        onClick={handleFocusClicked}
        sx={{ ml: -0.25 }}
      >
        <MaterialSymbolIcon
          symbol={MaterialSymbols.Target}
          sx={{ color: sessionUserOwnership?.isFocused ? theme.palette.primary.main : undefined }}
        />
      </IconButton>

      <Tooltip
        title={
          ownersInFocus.length > 0 ? (
            <Typography>
              {ownersInFocus
                .sort((a, b) => a.user.displayName.localeCompare(b.user.displayName))
                .map((u, i) => [
                  <Typography key={i} sx={{ display: "inline-block", fontSize: 13, marginRight: "2px" }}>
                    <Link key={i} href={Links.User(u.user.userId)}>
                      {u.user.displayName}
                    </Link>
                    {i < ownersInFocus.length - 1 && ", "}
                  </Typography>,
                ])}
            </Typography>
          ) : null
        }
        disableTouchListener={ownersInFocus.length === 0}
        disableHoverListener={ownersInFocus.length === 0}
      >
        <Typography variant="caption" sx={{ cursor: "pointer" }}>
          {ownersInFocus.length}
        </Typography>
      </Tooltip>
    </Stack>
  );
};

export { TaskItemFocusCharm };
